export default "Réseaux de chaleur urbains (EnR&R) : extension, densification et primes CEE. Accompagnement des collectivités de l'audit au dépôt des dossiers.";
